/** Shared dialog styling for text/email template editors (high dark-mode contrast). */

export const TEMPLATE_MODAL_OVERLAY_CLASS =
  'bg-black/80 backdrop-blur-[2px] dark:bg-black/95 dark:backdrop-blur-md'

const TEMPLATE_MODAL_SURFACE_CLASS = [
  'template-modal',
  'border',
  'bg-card',
  'shadow-xl',
  'ring-1',
  'ring-border/50',
  // Elevated slate panel — much lighter than page bg (hsl ~5% L) in dark mode
  'dark:bg-slate-700',
  'dark:border-slate-400/70',
  'dark:ring-2',
  'dark:ring-white/10',
  'dark:shadow-[0_0_0_1px_rgba(255,255,255,0.12),0_28px_56px_rgba(0,0,0,0.95)]',
].join(' ')

/** Portaled select menus opened from template modals */
export const TEMPLATE_MODAL_SELECT_CONTENT_CLASS =
  'dark:bg-slate-800 dark:border-slate-500/70 dark:text-slate-50'

export const TEXT_TEMPLATE_EDITOR_DIALOG_CLASS = [
  'sm:max-w-[900px]',
  'max-h-[90vh]',
  'overflow-y-auto',
  TEMPLATE_MODAL_SURFACE_CLASS,
].join(' ')

export const TEXT_TEMPLATE_PREVIEW_DIALOG_CLASS = [
  'sm:max-w-[700px]',
  'max-h-[90vh]',
  TEMPLATE_MODAL_SURFACE_CLASS,
].join(' ')

export const EMAIL_TEMPLATE_EDITOR_DIALOG_CLASS = [
  'sm:max-w-[1000px]',
  'max-h-[90vh]',
  'overflow-y-auto',
  TEMPLATE_MODAL_SURFACE_CLASS,
].join(' ')

export const EMAIL_TEMPLATE_PREVIEW_DIALOG_CLASS = [
  'sm:max-w-[900px]',
  'max-h-[90vh]',
  TEMPLATE_MODAL_SURFACE_CLASS,
].join(' ')

export const TEMPLATE_MODAL_TABS_LIST_CLASS =
  'bg-muted/80 dark:bg-slate-800 dark:border dark:border-slate-500/50'

export const TEMPLATE_MODAL_TABS_TRIGGER_CLASS =
  'dark:text-slate-200 dark:data-[state=active]:bg-slate-600 dark:data-[state=active]:text-white dark:data-[state=active]:shadow-sm dark:data-[state=active]:ring-1 dark:data-[state=active]:ring-slate-400/40'
